import { KeycloakService } from 'keycloak-angular';
import { throwError as observableThrowError ,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, Request, RequestOptions } from '@angular/http';
import { map,catchError } from 'rxjs/operators'
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthHeaderService } from '../authheader.service';
import { environment } from '../../../environments/environment';

@Injectable()

export class LoginService {
    public url:string;
constructor(private http:Http,
    private _headerService:AuthHeaderService ,
    private keycloak:KeycloakService
    ){
        this.url=environment.userdetailsurl; 
}
async Login(){
  let header = new Headers();
  let token = await this.keycloak.getToken();
  header.append("Content-Type", "application/json");
  header.append("enable-cors", "true");
  header.append("Access-Control-Allow-Origin", "*");
  //if (token) {
    header.append("Authorization", "Bearer "+token);
  localStorage.setItem("token",token);
    // header.append('Authorization', 'Bearer ' + token);
  //}
  let options = new RequestOptions({ headers: header});
  return this.http.get(this.url,options).pipe(map(response=>response.json()),catchError((error:Response)=>{return observableThrowError(error);}));
}
}
